/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { ButtonHTMLAttributes, FC } from 'react';

import { icons } from '@assets/index';

import { ConstructorCardButton } from './styled/ConstructorStyled';

interface IConstructorScheduleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: string;
  }

const ConstructorScheduleButton: FC<IConstructorScheduleButtonProps> = ({
    children,
    icon = icons.calendarDateIconBlue,
    ...props
}) => {
    return (
        <ConstructorCardButton {...props} >
            <img alt="schedule-icon" src={icon} />
            {children}
        </ConstructorCardButton>
    );
};

export default ConstructorScheduleButton;
